<template>
  <div>
    <div
      :id="idPopover"
      :key="idPopover"
      :style="`padding: ${padding}`"
      :class="`three-dots tw-cursor-pointer tw-flex tw-items-center tw-h-full ${styleButton}`"
      :data-cy="dataCyId"
      @click="onclick"
    >
      <ThreeDots />
    </div>
    <div>
      <b-popover
        :class="!popoverShow ? 'tw-invisible' : ''"
        :target="idPopover"
        triggers="hover"
        placement="bottom-end"
        :custom-class="`custom-actions-popover ${bPopover}`"
        :offset="offset"
        :delay="{
          show: 0,
          hide: 9999999999999,
        }"
      >
        <slot name="header" />
        <slot name="default" />
      </b-popover>
    </div>
  </div>
</template>

<script lang="ts" setup>
import ThreeDots from "@/components/svgs/threeDots.vue";
import { ref, onMounted, onBeforeUnmount } from "vue";
import EventEmitter, { EmitterEvents } from "@/utils/eventEmitter";

const props = defineProps({
  idPopover: {
    type: String,
    required: true,
  },
  padding: {
    type: String,
    default: "0px",
  },
  styleButton: {
    type: String,
    default: "",
  },
  offset: {
    type: Number,
    default: 25,
  },
  disable: {
    type: Boolean,
    default: false,
  },
  dataCyId: {
    type: String,
    default: "",
  },
  bPopover: {
    type: String,
    required: false,
    default: "",
  },
});
const popoverShow = ref(false);
defineExpose({
  popoverShow,
});

const handleClickOutside = (event: MouseEvent) => {
  const button = document.getElementById(props.idPopover);
  const popover = document.querySelector(".b-popover");

  if (
    button &&
    !button.contains(event.target as Node) &&
    popover &&
    !popover.contains(event.target as Node)
  ) {
    popoverShow.value = false;
  }
};

onMounted(() => {
  EventEmitter.on(EmitterEvents.HIDDEN_SETTINGS, () => {
    popoverShow.value = false;
    // setTimeout(() => {
    //   popoverShow.value = true;
    // }, 10);
  });
  window.addEventListener("click", handleClickOutside);
});

onBeforeUnmount(() => {
  window.removeEventListener("click", handleClickOutside);
  EventEmitter.off(EmitterEvents.HIDDEN_SETTINGS);
});

const onclick = () => {
  !props.disable && (popoverShow.value = !popoverShow.value);
};
</script>

<style lang="scss" scoped>
:deep(.popover-body) {
  min-width: 160px;
  width: 241px;
  border: none;
  box-shadow: 0px 0px 20px 0px rgba(0, 0, 0, 0.2);
  border-radius: 6px;
}

:deep(.popover-body) > *:first-child {
  border-top-left-radius: 8px;
  border-top-right-radius: 8px;
}

:deep(.popover-body) > *:last-child {
  border-bottom-left-radius: 8px;
  border-bottom-right-radius: 8px;
}
</style>
